import apiClient, { publicApiClient } from './client';

export interface UploadLinkResponse {
  id: string;
  token: string;
  url: string;
  expires_at: string;
  used_at?: string;
  file_id?: string;
  transcription_id?: string;
  created_at: string;
}

export interface PublicUploadLinkStatusResponse {
  status: 'ready';
  expires_at: string;
  used_at?: string;
  file_id?: string;
  transcription_id?: string;
}

export interface PublicUploadLinkInitiateResponse {
  file_id: string;
  upload_url: string;
  expires_at: string;
  exists: boolean;
}

export interface UploadLinkConfirmResponse {
  file_id: string;
  transcription_id: string;
  status: string;
}

export async function createUploadLink(params?: { expires_in?: string }): Promise<UploadLinkResponse> {
  const response = await apiClient.post<UploadLinkResponse>('/upload-links', params ?? {});
  return response.data;
}

export async function getUploadLink(id: string): Promise<UploadLinkResponse> {
  const response = await apiClient.get<UploadLinkResponse>(`/upload-links/${id}`);
  return response.data;
}

export async function getPublicUploadLinkStatus(token: string): Promise<PublicUploadLinkStatusResponse> {
  const response = await publicApiClient.get<PublicUploadLinkStatusResponse>(`/public/upload-links/${token}`);
  return response.data;
}

export async function initiatePublicUploadLinkUpload(token: string, params: {
  file_name: string;
  content_type: string;
  file_size: number;
  estimated_duration_seconds?: number;
  language?: string;
}): Promise<PublicUploadLinkInitiateResponse> {
  const response = await publicApiClient.post<PublicUploadLinkInitiateResponse>(
    `/public/upload-links/${token}/initiate`,
    params
  );
  return response.data;
}

export async function confirmPublicUploadLinkUpload(token: string): Promise<UploadLinkConfirmResponse> {
  const response = await publicApiClient.post<UploadLinkConfirmResponse>(`/public/upload-links/${token}/confirm`);
  return response.data;
}

